// =============================================================================
// SITE CONFIGURATION — La Table du Prince (Paris 14e)
// =============================================================================
// Master configuration for La Table du Prince restaurant website.
// Controls styling, localization, reservations, SEO, and integrations.
// =============================================================================

import type { SiteConfig } from '@webzite/content-schema';

const siteConfig: SiteConfig = {
  // =========================================================================
  // VISUAL STYLE
  // =========================================================================
  // "classic-brasserie" matches the authentic Parisian brasserie aesthetic
  // with walnut wood tones, ivory surfaces, burgundy accents, and antique gold.
  stylePack: 'classic-brasserie',

  // =========================================================================
  // GEOGRAPHIC REGION
  // =========================================================================
  // European Union — EU-14 allergen regulations, GDPR cookie consent.
  region: 'eu',

  // =========================================================================
  // LANGUAGE & LOCALIZATION
  // =========================================================================
  defaultLocale: 'fr',
  locales: ['fr', 'en', 'zh', 'de', 'it', 'pt'],
  currency: 'EUR',

  // =========================================================================
  // RESERVATIONS
  // =========================================================================
  reservations: {
    enabled: true,
    provider: 'thefork',
    bookingUrl: 'https://www.thefork.fr/restaurant/table-du-prince-r813818#booking=',
  },

  // =========================================================================
  // DELIVERY PLATFORMS
  // =========================================================================
  delivery: {
    enabled: false,
    platforms: [],
  },

  // =========================================================================
  // MAP
  // =========================================================================
  maps: {
    provider: 'osm',
    embedUrl:
      'https://www.openstreetmap.org/export/embed.html?bbox=2.3240,48.8290,2.3340,48.8345&layer=mapnik&marker=48.8317,2.3291',
    googleMapsLink:
      'https://maps.google.com/?q=La+Table+du+Prince+8+Rue+Mouton-Duvernet+75014+Paris',
    appleMapsLink:
      'https://maps.apple.com/?q=La+Table+du+Prince+8+Rue+Mouton-Duvernet+75014+Paris',
  },

  // =========================================================================
  // ANALYTICS
  // =========================================================================
  analytics: {
    cloudflare: { enabled: true },
    ga4: {
      enabled: false,
      measurementId: '',
    },
  },

  // =========================================================================
  // SEO (Search Engine Optimization)
  // =========================================================================
  seo: {
    titleTemplate: '%s | La Table du Prince - Restaurant Paris 14',
    defaultDescription:
      'Restaurant traditionnel français au 8 Rue Mouton-Duvernet, Paris 14e. Viandes sélectionnées, brunchs du week-end et desserts maison. Réservez votre table.',
    ogImage: '/images/og-image.png',
  },

  // =========================================================================
  // DEVELOPER ATTRIBUTION & WATERMARK
  // =========================================================================
  developer: {
    name: 'jeduapf',
    url: 'https://portfolio.jeduapf.com',
    role: 'Restaurant Web Developer',
    showFooterCredit: true,
  },

  // =========================================================================
  // ALLERGEN REGULATION
  // =========================================================================
  allergenRegulation: 'eu-fic-1169',
};

export default siteConfig;
